import React, { useEffect, useState } from 'react';
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import { toast } from 'react-toastify';
import instanciaAxios, { esErrorPermiso } from '../../miscelaneo/instanciaAxios';
import PlantillaModal from '../util/PlantillaModal';    
import TablaSucursal from '../util/tablas/TablaSucursal';
import { esEmailValido, esTelefonoValido } from '../util/ValidacionesCampos';

function MantenimientoAlmacen() {
    const [formData, setFormData] = useState({});
    const [cargando, setCargando] = useState(false);
    const [modo, setModo] = useState('creacion'); 
    const [editable, setEditable] = useState(true);
    const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
    const [mostarModalSucursal, setMostrarModalSucursal] = useState(false);


    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: type === 'checkbox' ? checked : value,
        }));
    };

    useEffect(() => {
          setEditable(modo !== 'ver');
          if(modo ==='ver'){
            setSucursalSeleccionada(null);
            toast.info('Modo solo observación');
          }
          if(modo ==='edicion'){
            setSucursalSeleccionada(null);
            toast.info('Modo edición');
          }
          if(modo ==='creacion'){
            setSucursalSeleccionada(null);
           toast.info('Modo creación');
          }
        }, [modo]);

    // El campo id_estado no se muestra en la interfaz, se maneja internamente con valor 1 (Activo)
    const campos = [
        { id: "descripcion", type: "text", label: "Descripción", placeholder: "Descripción", seccion: "Información de sucursal", required: true },
        { id: "telefono", type: "number", label: "Teléfono", placeholder: "Teléfono", seccion: "Información de sucursal", required: false },
        { id: "correo", type: "email", label: "Correo electrónico", placeholder: "Correo electrónico", seccion: "Información de sucursal", required: false }
    ];

    const camposPorSeccion = campos.reduce((acc, campo) => {
        if (!acc[campo.seccion]) acc[campo.seccion] = [];
        acc[campo.seccion].push(campo);
        return acc;
    }, {});

    async function SubmitSucursal() {
        if (cargando) return;
        const errores = [
            { cond: !formData.descripcion, msg: 'El campo descripcion es obligatorio' },
            { cond: formData.correo && !esEmailValido(formData.correo), msg: 'El formato del correo electrónico no es válido' },
            { cond: formData.telefono && !esTelefonoValido(formData.telefono), msg: 'El formato del teléfono no es válido (debe tener 10 dígitos)' },
        ];

        for (let error of errores) {
            if (error.cond) {
                toast.error(error.msg);
                return;
            }
        }

        try {
            let id_sucursal_ = formData.id_sucursal;
            
            // El estado siempre se establece en 1 (Activo) internamente
            const payload = {
                ...formData,
                id_estado: 1
            }; 

            if(modo === 'ver'){
                toast.info('Se encuentra en modo solo observación no se puede guardar nada ');
                return;
            }

            setCargando(true);

            if (modo === 'creacion') {
                const respuesta = await instanciaAxios.post('/miscelaneo/sucursal', payload);
                id_sucursal_ = respuesta.data.id_sucursal;

                setFormData(prev => ({
                    ...prev,
                    id_sucursal: id_sucursal_,
                    id_estado: 1
                }));

                toast.success('Sucursal registrada con éxito');
            }

            if (modo === 'edicion') {
                await instanciaAxios.put('/miscelaneo/sucursal', payload);
                toast.success('Sucursal editada con éxito');
            }

            setModo('ver');
        } catch (error) {
            if (esErrorPermiso(error)) return;
            toast.error('Error al guardar la sucursal');
            console.error(error);
        } finally {
            setCargando(false);
        }

    }

    async function handleBotonBuscar() {
    try {
    setMostrarModalSucursal(true);
      setModo('ver');
    } catch (error) {
      console.log(error);
    }
  }

  async function handleSeleccionarSucursal(sucursal) {
  try {
    console.log('Sucursal seleccionada:', sucursal);
    setSucursalSeleccionada(sucursal);
    setFormData(sucursal); // << Carga los datos al formulario
    setMostrarModalSucursal(false); // Cierra el modal
  } catch (error) {
    console.log(error);
  }
}


  async function handleBotonEditar() {
    try {
      setMostrarModalSucursal(true)
      setModo('edicion');
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBotonCrear() {
    try {
      setModo('creacion');
      setFormData({
        id_estado: 1  // Estado por defecto: Activo
      });
    } catch (error) {
      console.log(error);
    }
  }

    return (
        <div className="bg-gray-200 min-h-screen">
            <div className="flex justify-center py-10">
                <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-12 w-full max-w-7xl mx-10">
                    <form className="flex flex-col gap-8">
                        <div className="space-y-1">
                            <h1 className="font-cascadia font-bold text-2xl">Sucursal</h1>
                            <p className="text-gray-500">
                                Complete los campos y administre la información de cada sucursal.
                            </p>
                        </div>
                        {Object.entries(camposPorSeccion).map(([titulo, campos]) => (
                            <div key={titulo}>
                                <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                                <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
                                    {campos.map((campo) => (
                                        <div key={campo.id} className="flex flex-col">
                                            <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                {campo.label}
                                                {campo.required && <span className="text-red-500">*</span>}
                                            </label>
                                            {campo.type === "select" ? (
                                                <select
                                                    id={campo.id}
                                                    value={formData[campo.id] || ""}
                                                    onChange={handleChange}
                                                    disabled={!editable}
                                                    className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                        campo.required && editable
                                                            ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                            : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                    }`}
                                                >
                                                    <option value="">Seleccione una opción</option>
                                                    {campo.opciones?.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type={campo.type}
                                                    id={campo.id}
                                                    value={formData[campo.id] || ""}
                                                    onChange={handleChange}
                                                    placeholder={campo.placeholder}
                                                    disabled={!editable}
                                                    className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                        campo.required && editable
                                                            ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                            : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                    }`}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </form>
                    <DockVerticalDerecha
                    handleBotonGuardar={(e) => SubmitSucursal(e)}
                    handleBotonCrear={() => handleBotonCrear()}
                    handleBotonBuscar={() => handleBotonBuscar()}
                    handleBotonEditar={() => handleBotonEditar()}
                    guardando={cargando}
                    />
                    
                    <PlantillaModal
                        mostrar={mostarModalSucursal}
                        onClose={() =>setMostrarModalSucursal(false)}
                    >
                        <TablaSucursal
                            descripcion={'Seleccione la sucursal para ver o editar.'}
                            setSucursalSeleccionada={handleSeleccionarSucursal}
                        />
                    </PlantillaModal>
                </div>
            </div>
        </div>
    );
}

export default MantenimientoAlmacen;
